import { z } from 'zod';
import { FilterFieldRef } from './filter-rule.js';

/**
 * ColumnConfig — настраиваемые колонки таблицы (BE-9, концепт §6).
 *
 * Хранится в `task_module_saved_views.column_config` (JSONB). `scope` —
 * `project` (свой набор на странице проекта) или `global` (на /work-tasks).
 * `field` — системный ключ ∪ `cf:<key>` (как в FilterRule). Порядок массива =
 * порядок колонок; `width` px; `pinned: 'left'` закрепляет слева.
 */

export const ColumnScope = z.enum(['project', 'global']);
export type ColumnScope = z.infer<typeof ColumnScope>;

export const ColumnSpec = z
  .object({
    field: FilterFieldRef,
    width: z.number().int().min(48).max(800),
    pinned: z.enum(['left']).nullable().optional(),
    visible: z.boolean(),
  })
  // zod-strict-ok: dual-use, input-validated в SavedViewCreate (contract-тест требует strict)
  .strict();
export type ColumnSpec = z.infer<typeof ColumnSpec>;

export const ColumnConfig = z
  .object({
    scope: ColumnScope,
    columns: z.array(ColumnSpec).max(60),
  })
  // zod-strict-ok: dual-use, input-validated в SavedViewCreate
  .strict();
export type ColumnConfig = z.infer<typeof ColumnConfig>;
